import { Result, Town } from "@models";
import requests from "./agent";

export const townService = {
  getAll: async () => {
    const response = await requests.get<Result<Town[]>>(
      "/api/Town/GetAll"
    );
    return response.result;
  },
};
